<template>
  <div />
</template>


<script>
  import events from '@/services/events';


  export default {
    name: 'CheckGiftCardBalanceWrapper',

    /* https://v3.router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards */
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.modalOpenHandler();
      });
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    methods: {
      createdHandler() {
        events.on('check-balance:close', this.modalCloseHandler);
      },

      destroyedHandler() {
        events.off('check-balance:close', this.modalCloseHandler);
      },

      modalOpenHandler() {
        this.$openModal('checkGiftCardBalanceModal');
      },

      modalCloseHandler() {
        this.$router.push({
          name: 'orderMenu'
        });
      }
    }
  };
</script>
